import axios from 'axios'
import { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { IS_NEW_PALLET, LIKUT_WITHOUT_AZMANA_CLIENT, LOAD, LOAD_END, SAVE_CLIENTNAME, SELECT_PALLET } from '../../../../../../../../store/actions/actionsTypes'
import { GET_PDF_TEUDOT, GET_PRODUCT_TYPES } from '../../../../../../../modules/API/settings'
import { LikutModals } from '../../../../../../../modules/Context/CefiNum'
import { updateStatusAzmana } from '../../../../../../../modules/requests/updateAzmanaStatus'
import { addIDForTheList } from '../../../../../../../generic/utils/addUIDForTheList'
import { getOverweightFactor } from '../../../../../../../generic/utils/overweight'
import { useBrodMigdal } from '../../../../../../../generic/hooks/useBrodMigdal'
import { Certificates } from '../../../../../../../modules/API/Certificates/certificates'
import { Defaults } from '../../../../../../../modules/API/Defaults/defaults'
import { Pallets } from '../../../../../../../modules/API/Pallets/pallets'
import { Orders } from '../../../../../../../modules/API/Orders/orders'
import { LINKS } from '../../../../../../../Routs/config'
import { SET_IS_OPEN } from '../../../../../../../../store/reducers/printer'
import { RootState } from '../../../../../../../../store/reducers/rootReducer'
import { PalletToChangeTypes } from '../../../../../../../modules/API/Pallets/models/palletToChange'
import { handleNotifications } from '../../../../../../../generic/utils/handleNotifications'
import useConfigLefiMishkal from '../../../useConfigLefiMishkal'
import { IPalletTypeItem } from '../../../../../../../modules/API/Defaults/models/pallets'
import { IClientsItem } from '../../../../../../../modules/API/Defaults/models/customers'
import { ICarItem } from '../../../../../../../modules/API/Defaults/models/cars'
import { IPalletAzmanaItem, ITempTeudaData, UsePalletSectionParams } from '../../types/palletSection'

const usePalletSection = ({ azmanaNum, palletList = [], handleFetchOrders }: UsePalletSectionParams) => {
    const navigate = useNavigate()
    const [isWeightCalculation, calcWeightPerUnit] = useConfigLefiMishkal()
    const defaultClientList = useSelector((state: RootState) => state.defaults?.clientList?.list);
    const { getBrodMigdal } = useBrodMigdal()
    const isHovaRehev = !!getBrodMigdal({ id: 340 })
    const defaultCarID = getBrodMigdal({ id: 427 }) as number
    const defaultTranzit = getBrodMigdal({ id: 5 }) as number
    const defaultPackage = getBrodMigdal({ id: 14, subId: '1' }) as number
    const [palletAzmana, setPalletAzmana] = useState<IPalletAzmanaItem[]>([])
    const [isOpenSelectDriver, setIsOpenSelectDriver] = useState(false);
    const [carList, setCarList] = useState<ICarItem[]>([])
    const [defaultCar, setDefaultCar] = useState<ICarItem | null>(null)
    const [tempTeudaData, setTempTeudaData] = useState<ITempTeudaData | null>(null)
    const [isAutomaticCreateTeuda, setIsAutomaticSaveTeuda] = useState(false);
    const [date, setDate] = useState<Date | string>(new Date());
    const [isOpenPrintWindow, setIsOpenPrintWindow] = useState(false);

    const [clientID, setClientID] = useState<number | null>(null)
    const [inputClients, setInputClients] = useState('')

    const getToken = useSelector((state: RootState) => state.mainReducer.token)
    const user = useSelector((state: RootState) => state.mainReducer.user);
    const printerState = useSelector((state: RootState) => state.printerReducer);
    const workerList = useSelector((state: RootState) => state.defaults.workerList);
    const defaultPrinterNum = () => {
        if (!user?.rights.includes("WORKER")) return null
        const wItem = workerList.find((e: any) => e.WorkerID === (user as any)?.WorkerID)
        if (!wItem) return null
        return wItem.DefaultPrinter
    }
    const controller = useRef(new AbortController());
    const likutInfo = useSelector((state: RootState) => state.likut) as any;
    const chekLikut = likutInfo?.withoutAzmana;
    const dispatch = useDispatch()
    const [resonState, setResonState] = useContext<any>(LikutModals);
    const [isOpenModalPallets, setIsOpenModalPallets] = useState(false);
    const [numMishtah, setNumMishtah] = useState<number | null>(null);

    const [azmanotListForSiumLikut, setAzmanotListForSiumLikut] = useState<any[]>([]);
    const [azmanaDetails, setAzmanaDetails] = useState<any>(null);
    const [siumModalIsOpen, setSiumModalIsOpen] = useState(false);
    const [orderTypes, setOrderTypes] = useState<any>({})
    const defaultPackageList = useSelector((state: RootState) => state.defaults.packageList);
    const activeArizotCalc = !!getBrodMigdal({ id: 583 })
        && (orderTypes[likutInfo.azmanaGroup] ?
            orderTypes[likutInfo.azmanaGroup]?.control : true)

    const isExistUncheckedPallet = palletAzmana?.some(e => e.CheckDate === '00000000')

    const alertIfExistUnckeckedPallet = () => {
        handleNotifications('קיים משטח שלא נבדק', { type: "warning" })
    }

    const handleControlPalletModal = () => {
        setIsOpenModalPallets(!isOpenModalPallets)
    }

    const getPalletTypesForClient = async () => {
        try {
            let res = await Pallets.getPalletTypesForClient(clientID || likutInfo.clientId)
            const find = res.filter((pallet: any) => pallet.IsMainCode);
            if (find.length > 0) {
                defaultPallet(find[0].Pallete_Type)
            } else {
                defaultPallet()
            }
        } catch (err) {

        }
    }
    useEffect(() => {
        getPalletTypesForClient()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientID, likutInfo.clientId])

    const getProdTypes = async () => {
        try {
            let response = await axios.get(`${GET_PRODUCT_TYPES}`, {
                headers: {
                    Authorization: 'Bearer ' + getToken
                },
                signal: controller.current.signal
            })
            let reduced = response.data.productsGroups.reduce((acc: any, cur: any) => {
                acc[cur.GroupID] = {
                    desc: cur.GroupDesc?.trim(),
                    control: +cur.Pallet_Control ? true : false
                }
                return acc
            }, {})
            setOrderTypes(reduced)

        } catch (err: any) {
            if (!axios.isCancel(err)) {
                handleNotifications(err?.response?.data?.message || "משהו השתבש", { type: "error" })
            }
        }
    }
    const getAzmanotDetailes = async (OrderID: number) => {
        dispatch({ type: LOAD })
        try {
            const res = await Orders.getOrderWithDetailsByOrderID(OrderID)
            dispatch({ type: LOAD_END })
            const { OrderDetails, ...rest } = res
            let concatArr = addIDForTheList(OrderDetails);
            // minus (undersupply) beyond 1 unit is always an anomaly;
            // plus (oversupply) is allowed up to the product CollectDeviation percent.
            const isAnomaly = (e: any) => {
                const factor = getOverweightFactor(e.CollectDeviation)
                const scanOrReason = e.ScanProblem !== 0 || e.ChangeReason === 4
                if (isWeightCalculation) {
                    const gaveLess = (e.OrderWeight - e.SupplyWeight) > calcWeightPerUnit(e)
                    const gaveMore = (e.SupplyWeight - e.OrderWeight * factor) > calcWeightPerUnit(e)
                    return gaveLess || gaveMore || scanOrReason
                }
                const gaveLess = e.OrderPacks - e.SupplyQty > 0
                const gaveMore = e.SupplyQty > e.OrderPacks * factor
                return gaveLess || gaveMore || scanOrReason
            }
            let sorted = concatArr.filter(isAnomaly).sort((a: any, b: any) => b.CollectorSort - a.CollectorSort)
            setAzmanotListForSiumLikut(sorted);
            setAzmanaDetails(rest)
            setSiumModalIsOpen(true);
        } catch (err: any) {
            dispatch({ type: LOAD_END })
            handleNotifications(err?.response?.data?.message || "משהו השתבש", { type: "error" })

        }

    }

    const siumLikut = async (num?: number) => {
        dispatch({ type: LOAD })
        try {
            await Orders.changeOrderStatus(num as number, 3)
            updateStatusAzmana(num as number, user, 3)
            dispatch({ type: LOAD_END });
            setSiumModalIsOpen(false);
            handleNotifications('תהליך הסתיים', { type: "success" })

            navigate(LINKS.likut.likutExperess.mainUrl);
            if (handleFetchOrders) {
                handleFetchOrders()
            }

        } catch (err: any) {
            dispatch({ type: LOAD_END })
            handleNotifications(err?.response?.data?.message || "משהו השתבש", { type: "error" })
        }
    }
    // set deafault value for palletType list, in work
    const defaultPallet = (defaulType?: number) => {

        const defType = (defaulType as number) | defaultPackage
        const filteredVal = palletList.filter(e => e?.Pallete_Type === defType)

        if (filteredVal.length > 0) {

            dispatch({
                type: SELECT_PALLET, payload:
                {
                    palletNum: 999999,
                    palletDesc: filteredVal[0].Pallete_Desc?.trim(),
                    palletType: filteredVal[0].Pallete_Type

                }
            });
        }
        return filteredVal


    }

    const getPallet = async (id?: number | null) => {
        dispatch({ type: LOAD })
        try {
            const res = await Pallets.getPalletsByIDs(
                chekLikut ? 0 : (azmanaNum || likutInfo.azmanaNum),
                id || likutInfo.clientId || 0
            )
            setPalletAzmana(res.pallets);
            dispatch({ type: LOAD_END });



        } catch (err: any) {
            dispatch({ type: LOAD_END })
            handleNotifications(err?.response?.data?.message || "משהו השתבש", { type: "error" })

        }

    }


    const createTeuda = async (carIDParam?: number) => {
        dispatch({ type: LOAD })
        const palletsListReduced = palletAzmana.reduce((acc: number[], cur) => {
            acc.push(cur.Pallet_Num)
            return acc
        }, [])
        const certData = {
            CustomerID: clientID as number,
            DeliveryDate: date as string,
            DeliveryTime: "",
            OrderNum: 0,
            PalletNums: palletsListReduced,
            Tranzit: defaultTranzit || 0,
            Vehicle_Code: carIDParam || defaultCar?.CarID || defaultCarID || 0
        }
        try {
            const res = await Certificates.createCert(certData)
            setTempTeudaData(res)
            handleNotifications(`${res.deliveryNum}`, { type: "success" })

            setIsOpenPrintWindow(true)
            getPallet(clientID)
        } catch (err) {
            handleNotifications('שגיאה ביצירת תעודה', { type: "error" })
        } finally {
            dispatch({ type: LOAD_END })
        }
    }

    const checValidDataForTeuda = () => {
        /*
            first saving step: check brod migdal.
            If carID is required, pass default carID,
            if it exist - run createTeuda, if not - show select driver window
            If brod migdal - false, run createTeuda with previous selected driver or with carID = 0
        */
        if (isHovaRehev) {
            if (!defaultCar?.CarID && !defaultCarID) {
                // call modal for select driver
                setIsAutomaticSaveTeuda(true)
                handleSelectDriverModal()
                return
            }
        }
        createTeuda()
    }

    const handleSaveCarID = async (item: any) => {
        /*
            Select driver from the list and set default driver.
            @isAutomaticCreateTeuda - tell us that user already clicked create teuda,
            and we need to pass carID param to API request and run createTeuda function.
            Otherwise if isAutomaticCreateTeuda - false,
            user saving default driver and close window
        */
        setDefaultCar(item)
        if (isAutomaticCreateTeuda) {
            try {
                createTeuda(item.CarID)
            } catch (err) {
                return
            }
        }
        handleSelectDriverModal()
    }
    const handleSelectDriverModal = () => {
        setIsOpenSelectDriver(!isOpenSelectDriver)
    }
    const finishTeuda = () => {
        setIsOpenPrintWindow(false)
        setTempTeudaData(null);
        setClientID(null)
        setInputClients('');
    }
    const getExistPalletInfo = async (id: number) => {
        try {
            let res = await Pallets.getPalletItems(id)
            return res.detailsPallet
        }
        catch (err) {
        }
    }
    const printTeuda = async () => {
        dispatch({ type: LOAD });
        try {
            let response = await fetch(
                `${GET_PDF_TEUDOT}deliveryNum=${tempTeudaData?.deliveryNum}&deliverySub=${tempTeudaData?.deliverySub}`,
                {
                    headers: {
                        Authorization: "Bearer " + getToken,
                    },
                }
            );
            const data = await response.blob();
            // Receive PDF Steam as as Blob
            const file = new Blob([data], { type: "application/pdf" }); //Create a Blob from the PDF Stream
            const fileURL = URL.createObjectURL(file); //Build a URL from the file
            window.open(fileURL); //Open the URL on new Window
            finishTeuda()
        } catch (err) {
            //   console.log(err);
        } finally {
            dispatch({ type: LOAD_END });
        }
    };

    const printPallet = async (pallet_num: number) => {
        dispatch({ type: LOAD });
        try {
            const data = {
                "ZPL_15_75": 3,
                "PalletEntryNum": +pallet_num,
                "PalletZPLFormat": +(printerState.formatID ?? 0),
                "ChangeInternationalEncodingZPL": printerState.encoding
            }
            const defPrinter = printerState.printerID || defaultPrinterNum()
            let res = await Pallets.printPalletZPL(defPrinter, data)

            if (typeof res !== 'number') {
                let modifyed = res.split('.il').join('.il:9086');
                window.open(modifyed);
            } else {
                setResonState({
                    ...resonState,
                    'resonTag': 'success',
                    'active': true
                })
            }
            dispatch({ type: LOAD_END });
        } catch (err: any) {
            if (err?.response?.status === 404) {
                handleNotifications('שגיאה הדפסת משטח', { type: "error" })

            }
            else {
                handleNotifications(err?.response?.data?.message || "משהו השתבש", { type: "error" })
            }
            dispatch({ type: LOAD_END });
        }
    }

    // collect data from selected client
    const selectClient = (name: string, id: number) => {
        setClientID(id);
        setInputClients(name)
        dispatch({ type: LIKUT_WITHOUT_AZMANA_CLIENT, payload: id })
        dispatch({ type: SAVE_CLIENTNAME, payload: name })
    }

    const handleSelectClient = (customer: IClientsItem | null) => {
        if (!customer) return
        selectClient(customer.Customer_Name.trim(), customer.CustomerID)
        getPallet(customer.CustomerID)
    }

    const handleClickNewPallet = () => {
        if (isExistUncheckedPallet && activeArizotCalc) {
            alertIfExistUnckeckedPallet()
            return
        }
        if (likutInfo?.pallet?.palletType) {
            if (likutInfo.withoutAzmana && !likutInfo?.clientId) {
                handleNotifications('בחר לקוח', { type: "warning" })

            }
            dispatch({
                type: SELECT_PALLET, payload:
                {
                    palletNum: 999999,
                    palletDesc: likutInfo?.pallet?.palletDesc,
                    palletType: likutInfo?.pallet?.palletType

                }
            });
            dispatch({ type: IS_NEW_PALLET, payload: true });
        }
        else {
            handleNotifications('בחר סוג משטח', { type: "warning" })
        }

    }

    const getCars = async () => {
        try {
            let res = await Defaults.getCarList();
            setCarList(res.cars)
            if (isHovaRehev && defaultCarID !== 0) {
                /*
                    If isHovaRehev is true and defaultCarID is not 0, it will find the car in res.cars with the specified defaultCarID.
                    If the car is found, it will be set as the default car using setDefaultCar.
                    If the car is not found, setDefaultCar will be called with a value of null.
                */
                let def = res.cars.find((e: any) => e.CarID === defaultCarID)
                setDefaultCar(def || null)
            }
        } catch (err) {

        }
    }
    const handleClickPrint = (palletNum: number) => {
        if (printerState.printerID && printerState.formatID) {
            printPallet(palletNum)
        } else {
            dispatch({ type: SET_IS_OPEN, payload: true })
        }
    }

    // moved verbatim from LikutPalletTypeList onChange
    const handleSelectPalletType = (item: IPalletTypeItem | null) => {
        if (!item) return
        if (isExistUncheckedPallet && activeArizotCalc) {
            alertIfExistUnckeckedPallet()
            return
        }
        dispatch({ type: IS_NEW_PALLET, payload: true });
        dispatch({
            type: SELECT_PALLET, payload:
            {
                palletNum: 999999,
                palletDesc: item.Pallete_Desc?.trim(),
                palletType: item.Pallete_Type
            }
        });
        navigate(LINKS.likut.likutExperess.likutWorkSection)
    }

    const selectedPalletTypeItem = palletList.find(p => p.Pallete_Type === likutInfo?.pallet?.palletType) ?? null

    // moved verbatim from likutExpressPalletItem click
    const handleOpenPallet = (pallet: IPalletAzmanaItem, index: number) => {
        setNumMishtah(index + 1)
        navigate(LINKS.likut.likutExperess.likutWorkSection)
        dispatch({ type: IS_NEW_PALLET, payload: likutInfo.azmanaStatus === 7 ? false : true });
        dispatch({
            type: SELECT_PALLET, payload:
            {
                palletNum: pallet.Pallet_Num,
                palletDesc: +`${pallet.Pallet_Num}`
            }
        });
    }

    // folds the old Link's conditional target: invalid state linked to the same page (no-op)
    const handleNewPallet = () => {
        handleClickNewPallet()
        const isInvalidState =
            (likutInfo.withoutAzmana && !likutInfo?.clientId) ||
            !likutInfo?.pallet?.palletType ||
            (isExistUncheckedPallet && activeArizotCalc)
        if (!isInvalidState) {
            navigate(LINKS.likut.likutExperess.likutWorkSection)
        }
    }

    const handleBack = () => {
        navigate(LINKS.likut.likutExperess.mainUrl)
    }

    const selectedCustomer = defaultClientList?.find((c: IClientsItem) => c.CustomerID === clientID) ?? null

    const palletQtySum = palletAzmana?.reduce((acc, cur) => {
        return acc + (cur.PalletQty)
    }, 0) || 0

    useEffect(() => {
        if (chekLikut) {
            getCars();
        }
        else {
            getPallet();
        }
        getProdTypes()
        return () => {
            controller.current.abort("Component got unmounted");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setTempTeudaData(null)
    }, [clientID])
    const handleOpenPrinterSettings = () => {
        dispatch({ type: SET_IS_OPEN, payload: true })
    }

    const palletModalProps = {
        id: azmanaNum || likutInfo.azmanaNum,
        type: PalletToChangeTypes.ORDER,
        palletTypeList: palletList,
        saveFunc: handleControlPalletModal
    }

    return {
        // pallets
        palletAzmana,
        isExistUncheckedPallet,
        activeArizotCalc,
        palletQtySum,
        handleOpenPallet,
        // teuda flow
        tempTeudaData,
        isOpenPrintWindow,
        printTeuda,
        finishTeuda,
        checValidDataForTeuda,
        // driver
        isOpenSelectDriver,
        handleSelectDriverModal,
        setIsAutomaticSaveTeuda,
        carList,
        defaultCar,
        handleSaveCarID,
        // clients (chekLikut)
        chekLikut,
        clientID,
        inputClients,
        defaultClientList,
        selectedCustomer,
        handleSelectClient,
        setDate,
        // sium likut
        siumModalIsOpen,
        setSiumModalIsOpen,
        azmanotListForSiumLikut,
        azmanaDetails,
        siumLikut,
        getAzmanotDetailes,
        isWeightCalculation,
        defaultPackageList,
        // pallet type select
        selectedPalletTypeItem,
        handleSelectPalletType,
        // pallets modal
        isOpenModalPallets,
        handleControlPalletModal,
        palletModalProps,
        // printing / printers
        printerState,
        defaultPrinterNum,
        handleOpenPrinterSettings,
        handleClickPrint,
        printPallet,
        // new pallet / navigation
        handleNewPallet,
        handleBack,
        // work section props
        getPallet,
        getExistPalletInfo,
        numMishtah,
        // misc
        likutInfo,
    }
}

export default usePalletSection;
